const Card = ({ 
  children, 
  className = '', 
  hover = false, 
  padding = true,
  shadow = true,
  onClick,
  ...props 
}) => {
  const baseClasses = 'bg-white rounded-lg overflow-hidden'
  const hoverClasses = hover ? 'transform transition-all duration-300 hover:scale-105 hover:shadow-lg cursor-pointer' : ''
  const paddingClasses = padding ? 'p-4' : ''
  const shadowClasses = shadow ? 'shadow-md' : ''
    
  const finalClasses = `${baseClasses} ${hoverClasses} ${paddingClasses} ${shadowClasses} ${className}`
    
  return (
    <div 
      className={finalClasses}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  )
}

export default Card